import { createCodeParser } from '@carafe/components';
import { CentralAuthErrorCode } from '@carafe/errors';

/**
 * Statically create and export an error code parser for use throughout the
 * application.
 */
export const errorCodeParser = createCodeParser(CentralAuthErrorCode);
